export default "__VITE_ASSET__BSCI5ImC__ 720w";